import React from "react"
import { ExternalLinkWrapper } from "../ExternalLinkWrapper"
import { BodyTextRegular } from "../typography/text"
import { Link, useI18next } from "gatsby-plugin-react-i18next"

type Props = {
  href: string
  children: React.ReactNode
  internalLink?: boolean
  className?: string
}

export const FooterLink = ({
  href,
  children,
  internalLink = false,
  className,
}: Props) => {
  const { language } = useI18next()

  if (internalLink) {
    return (
      <Link
        to={href}
        language={language}
        className={`${className ? className : ""} text-textPrimary cursor-pointer no-underline hover:text-ctaMain`}
      >
        <BodyTextRegular>{children}</BodyTextRegular>
      </Link>
    )
  }

  return (
    <ExternalLinkWrapper
      href={href}
      className={`${className ? className : ""} text-textPrimary cursor-pointer no-underline hover:text-ctaMain`}
    >
      <BodyTextRegular>{children}</BodyTextRegular>
    </ExternalLinkWrapper>
  )
}
